export default __webpack_public_path__ + "static/media/grafema_gim-tonico_10.46df082f.jpg";